import { baseURL, DownloadUrl,WebUrl } from './base';
import { Apis, ApiUrl } from './api';

export {
    baseURL,
    DownloadUrl,
    WebUrl,
    Apis,
    ApiUrl
}



// WEBPACK FOOTER //
// ./src/api/index.js